module.exports = __webpack_public_path__ + "static/media/interior4.00f2b320.svg";